import { Component, Children } from 'react';
import { connect } from 'react-redux';
import { loadFeatureFlags } from 'reducers/featureFlags/actions';
import isFeatureFlagReady from 'selectors/isFeatureFlagReady';
import getMokaUserEmail from 'selectors/getMokaUserEmail';
import getMokaUserId from 'selectors/getMokaUserId';
import { hasFeature } from 'utils/featureFlags';

class FeatureFlagProvider extends Component {
  componentDidUpdate(prevProps) {
    const { userId, userEmail } = this.props;

    // This handles case where `userId` or `userEmail` change. However, this
    // shouldn't happen since the user session is fixed.
    if (userId !== prevProps.userId || userEmail !== prevProps.userEmail) {
      this.loadFlags();
    }
  }

  loadFlags = () => {
    const { userId, userEmail, loadFeatureFlags } = this.props;

    // This is the flag provider so it has to get from the bottom
    if (hasFeature('enable-user-targeting')) {
      let attributes;
      if (userEmail) {
        attributes = {
          email: userEmail,
        };
      }

      loadFeatureFlags(userId, attributes);
    } else {
      loadFeatureFlags();
    }
  };

  render() {
    const { isReady } = this.props;

    if (isReady) {
      return Children.only(this.props.children);
    }
    return null;
  }
}

const mapStateToProps = state => {
  return {
    isReady: isFeatureFlagReady(state),
    userId: getMokaUserId(state),
    userEmail: getMokaUserEmail(state),
  };
};

const mapDispatchToProps = {
  loadFeatureFlags,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeatureFlagProvider);
